import React from 'react'
import { RatioLink } from 'src/components/page/ratios/ratios'

import * as styles from './basic-ratios.module.scss'

export interface Props {
  marketCap: string
  enterpriseValue: string
  revenue: string
}

export const BasicRatios: React.FC<Props> = (props) => {
  const data = buildRatioData(props)
  return (
    <ul className={styles.basicRatios}>
      {data.map((item, index) => (
        <li key={index} className={styles.basicRatios__row}>
          <div className={styles.basicRatios__column}>
            <RatioLink id={item.id}>{item.label}</RatioLink>
          </div>
          <div className={styles.basicRatios__column}>{item.value}</div>
        </li>
      ))}
    </ul>
  )
}

interface RatioData {
  label: string
  id: string
  value: string
}

function buildRatioData(data: Props): ReadonlyArray<RatioData> {
  return [
    {
      label: 'Market Cap',
      value: data.marketCap,
      id: 'market-cap-sterling-millions-4851',
    },
    {
      label: 'Enterprise Value',
      value: data.enterpriseValue,
      id: 'enterprise-value-sterling-4861',
    },
    {
      label: 'Revenue',
      value: data.revenue,
      id: 'total-sales-sterling-millions-5086',
    },
  ]
}
